export const heatTrend = [
  { month: "3月", creator: 61, star: 78 },
  { month: "4月", creator: 66, star: 76 },
  { month: "5月", creator: 70, star: 74 },
  { month: "6月", creator: 74, star: 79 },
  { month: "7月", creator: 79, star: 77 },
  { month: "8月", creator: 83, star: 75 },
  { month: "9月", creator: 81, star: 78 },
];

export const dimensionRadar = [
  { dimension: "热度", creator: 92, star: 79 },
  { dimension: "话题", creator: 88, star: 76 },
  { dimension: "商业", creator: 85, star: 90 },
  { dimension: "专业", creator: 62, star: 94 },
  { dimension: "破圈", creator: 80, star: 92 },
  { dimension: "稳定性", creator: 71, star: 88 },
];

export const categoryShare = [
  { name: "直播同框", value: 32 },
  { name: "品牌代言", value: 24 },
  { name: "综艺同台", value: 18 },
  { name: "时尚红毯", value: 14 },
  { name: "影视选角", value: 12 },
];